/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganizationRequestDto,
  CreateOrganizationResponseDto,
  FindOrganizationDto,
  FindOrganizationTreeDto,
  FindOrganizationWithRelationsDto,
  ListOrganizationsResponseDto,
  UpdateOrganizationParentRequestDto,
  UpdateOrganizationRequestDto,
  UpdateOrganizationResponseDto,
} from '../models/index';
import {
    CreateOrganizationRequestDtoFromJSON,
    CreateOrganizationRequestDtoToJSON,
    CreateOrganizationResponseDtoFromJSON,
    CreateOrganizationResponseDtoToJSON,
    FindOrganizationDtoFromJSON,
    FindOrganizationDtoToJSON,
    FindOrganizationTreeDtoFromJSON,
    FindOrganizationTreeDtoToJSON,
    FindOrganizationWithRelationsDtoFromJSON,
    FindOrganizationWithRelationsDtoToJSON,
    ListOrganizationsResponseDtoFromJSON,
    ListOrganizationsResponseDtoToJSON,
    UpdateOrganizationParentRequestDtoFromJSON,
    UpdateOrganizationParentRequestDtoToJSON,
    UpdateOrganizationRequestDtoFromJSON,
    UpdateOrganizationRequestDtoToJSON,
    UpdateOrganizationResponseDtoFromJSON,
    UpdateOrganizationResponseDtoToJSON,
} from '../models/index';

export interface OrganizationControllerCreateOrganizationRequest {
    createOrganizationRequestDto: CreateOrganizationRequestDto;
}

export interface OrganizationControllerDeleteOrganizationRequest {
    id: string;
}

export interface OrganizationControllerFindAllOrganizationsRequest {
    limit: number;
    page: number;
    q?: string;
}

export interface OrganizationControllerFindOrganizationByIdRequest {
    id: string;
}

export interface OrganizationControllerFindOrganizationTreeRequest {
    id: string;
}

export interface OrganizationControllerFindOrganizationWithRelationsRequest {
    id: string;
}

export interface OrganizationControllerUpdateOrganizationRequest {
    id: string;
    updateOrganizationRequestDto: UpdateOrganizationRequestDto;
}

export interface OrganizationControllerUpdateOrganizationParentRequest {
    id: string;
    updateOrganizationParentRequestDto: UpdateOrganizationParentRequestDto;
}

/**
 * 
 */
export class OrganizationsApi extends runtime.BaseAPI {

    /**
     */
    async organizationControllerCreateOrganizationRaw(requestParameters: OrganizationControllerCreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationResponseDto>> {
        if (requestParameters['createOrganizationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createOrganizationRequestDto',
                'Required parameter "createOrganizationRequestDto" was null or undefined when calling organizationControllerCreateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationRequestDtoToJSON(requestParameters['createOrganizationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationControllerCreateOrganization(requestParameters: OrganizationControllerCreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationResponseDto> {
        const response = await this.organizationControllerCreateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationControllerDeleteOrganizationRaw(requestParameters: OrganizationControllerDeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationControllerDeleteOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async organizationControllerDeleteOrganization(requestParameters: OrganizationControllerDeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationControllerDeleteOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async organizationControllerFindAllOrganizationsRaw(requestParameters: OrganizationControllerFindAllOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOrganizationsResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling organizationControllerFindAllOrganizations().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling organizationControllerFindAllOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOrganizationsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationControllerFindAllOrganizations(requestParameters: OrganizationControllerFindAllOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOrganizationsResponseDto> {
        const response = await this.organizationControllerFindAllOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationControllerFindOrganizationByIdRaw(requestParameters: OrganizationControllerFindOrganizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOrganizationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationControllerFindOrganizationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOrganizationDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationControllerFindOrganizationById(requestParameters: OrganizationControllerFindOrganizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOrganizationDto> {
        const response = await this.organizationControllerFindOrganizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationControllerFindOrganizationTreeRaw(requestParameters: OrganizationControllerFindOrganizationTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOrganizationTreeDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationControllerFindOrganizationTree().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{id}/tree`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOrganizationTreeDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationControllerFindOrganizationTree(requestParameters: OrganizationControllerFindOrganizationTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOrganizationTreeDto> {
        const response = await this.organizationControllerFindOrganizationTreeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationControllerFindOrganizationWithRelationsRaw(requestParameters: OrganizationControllerFindOrganizationWithRelationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOrganizationWithRelationsDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationControllerFindOrganizationWithRelations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{id}/relations`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOrganizationWithRelationsDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationControllerFindOrganizationWithRelations(requestParameters: OrganizationControllerFindOrganizationWithRelationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOrganizationWithRelationsDto> {
        const response = await this.organizationControllerFindOrganizationWithRelationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationControllerUpdateOrganizationRaw(requestParameters: OrganizationControllerUpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateOrganizationResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationControllerUpdateOrganization().'
            );
        }

        if (requestParameters['updateOrganizationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationRequestDto',
                'Required parameter "updateOrganizationRequestDto" was null or undefined when calling organizationControllerUpdateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationRequestDtoToJSON(requestParameters['updateOrganizationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateOrganizationResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationControllerUpdateOrganization(requestParameters: OrganizationControllerUpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateOrganizationResponseDto> {
        const response = await this.organizationControllerUpdateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationControllerUpdateOrganizationParentRaw(requestParameters: OrganizationControllerUpdateOrganizationParentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOrganizationWithRelationsDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationControllerUpdateOrganizationParent().'
            );
        }

        if (requestParameters['updateOrganizationParentRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationParentRequestDto',
                'Required parameter "updateOrganizationParentRequestDto" was null or undefined when calling organizationControllerUpdateOrganizationParent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{id}/parent`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationParentRequestDtoToJSON(requestParameters['updateOrganizationParentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOrganizationWithRelationsDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationControllerUpdateOrganizationParent(requestParameters: OrganizationControllerUpdateOrganizationParentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOrganizationWithRelationsDto> {
        const response = await this.organizationControllerUpdateOrganizationParentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
